import React, { useState } from 'react';
import { Edit2, Plus, Check, Sparkles, Clock, MapPin, Briefcase, Save, ChevronDown } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
export function ProfiloPage() {
  // Active Tab State
  const [activeTab, setActiveTab] = useState<'azienda' | 'zone' | 'servizi' | 'disponibilita'>('azienda');
  // State for Zones
  const [selectedZones, setSelectedZones] = useState<string[]>(['Milano Centro', 'Milano - Navigli', 'Milano - Porta Venezia', 'Milano - Città Studi']);
  const allZones = ['Milano Centro', 'Milano - Navigli', 'Milano - Porta Venezia', 'Milano - Isola', 'Milano - Città Studi', 'Milano - Bovisa', 'Monza', 'Sesto San Giovanni'];
  // State for Services
  const [selectedServices, setSelectedServices] = useState<string[]>(['Pulizia standard', 'Deep cleaning', 'Cambio biancheria']);
  const allServices = ['Pulizia standard', 'Deep cleaning', 'Pulizia post-evento', 'Cambio biancheria', 'Lavanderia'];
  // State for Availability
  const [availability, setAvailability] = useState({
    Lun: true,
    Mar: true,
    Mer: true,
    Gio: true,
    Ven: true,
    Sab: false,
    Dom: false
  });
  // State for AI Preferences
  const [aiPreferences, setAiPreferences] = useState({
    suggestions: true,
    urgent: true
  });
  const toggleZone = (zone: string) => {
    if (selectedZones.includes(zone)) {
      setSelectedZones(selectedZones.filter(z => z !== zone));
    } else {
      setSelectedZones([...selectedZones, zone]);
    }
  };
  const toggleService = (service: string) => {
    if (selectedServices.includes(service)) {
      setSelectedServices(selectedServices.filter(s => s !== service));
    } else {
      setSelectedServices([...selectedServices, service]);
    }
  };
  const toggleDay = (day: keyof typeof availability) => {
    setAvailability({
      ...availability,
      [day]: !availability[day]
    });
  };
  const tabs = [{
    id: 'azienda',
    label: 'Azienda'
  }, {
    id: 'zone',
    label: 'Zone'
  }, {
    id: 'servizi',
    label: 'Servizi'
  }, {
    id: 'disponibilita',
    label: 'Orari'
  }] as const;
  return <MobileLayout data-id="element-1098">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-1099">
        <h1 className="text-xl lg:text-2xl font-montserrat font-bold text-navy" data-id="element-1100">
          Profilo Azienda
        </h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-1101">
          Gestisci le informazioni della tua attività
        </p>
      </div>

      {/* Tab Navigation - Underline style */}
      <div className="border-b border-gray-200 mb-6" data-id="element-1102">
        <div className="flex gap-6 -mb-px overflow-x-auto scrollbar-hide" data-id="element-1103">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                pb-3 text-sm font-medium whitespace-nowrap transition-all border-b-2
                ${activeTab === tab.id ? 'border-teal-deep text-teal-deep' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `} data-id="element-1104">
              {tab.label}
            </button>)}
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6 pb-20" data-id="element-1105">
        {/* AZIENDA TAB */}
        {activeTab === 'azienda' && <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-1106">
            <div className="flex items-center justify-between mb-4" data-id="element-1107">
              <div className="flex items-center gap-2" data-id="element-1108">
                <Briefcase size={14} className="text-gray-400" data-id="element-1109" />
                <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-1110">
                  Dati Aziendali
                </span>
              </div>
              <button className="p-2 text-gray-400 hover:text-teal-deep hover:bg-teal-50 rounded-lg transition-colors" data-id="element-1111">
                <Edit2 size={16} data-id="element-1112" />
              </button>
            </div>

            <div className="space-y-4" data-id="element-1113">
              <div data-id="element-1114">
                <label className="block text-xs text-gray-400 mb-1" data-id="element-1115">
                  Ragione Sociale
                </label>
                <div className="text-sm font-semibold text-navy" data-id="element-1116">
                  Pulizie Express S.r.l.
                </div>
              </div>

              <div data-id="element-1117">
                <label className="block text-xs text-gray-400 mb-1" data-id="element-1118">
                  Partita IVA
                </label>
                <div className="text-sm font-semibold text-navy" data-id="element-1119">
                  IT12345678901
                </div>
              </div>

              <div data-id="element-1120">
                <label className="block text-xs text-gray-400 mb-1" data-id="element-1121">
                  Indirizzo
                </label>
                <div className="text-sm font-semibold text-navy" data-id="element-1122">
                  Via Roma 123, 20121 Milano
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-1123">
                <div data-id="element-1124">
                  <label className="block text-xs text-gray-400 mb-1" data-id="element-1125">
                    Email
                  </label>
                  <div className="text-sm font-semibold text-navy" data-id="element-1126">
                    info@pulizieexpress.it
                  </div>
                </div>
                <div data-id="element-1127">
                  <label className="block text-xs text-gray-400 mb-1" data-id="element-1128">
                    Telefono
                  </label>
                  <div className="text-sm font-semibold text-navy" data-id="element-1129">
                    +39 02 1234567
                  </div>
                </div>
              </div>
            </div>

            {/* AI Preferences inside Azienda tab */}
            <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-1130">
              <div className="flex items-center gap-2 mb-4" data-id="element-1131">
                <Sparkles size={14} className="text-gray-400" data-id="element-1132" />
                <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-1133">
                  Preferenze AI
                </span>
              </div>

              <div className="space-y-4" data-id="element-1134">
                <div className="flex items-center justify-between" data-id="element-1135">
                  <div data-id="element-1136">
                    <div className="text-sm font-medium text-navy" data-id="element-1137">
                      Suggerimenti intelligenti
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-1138">
                      Ricevi suggerimenti in base alle tue zone
                    </div>
                  </div>
                  <button onClick={() => setAiPreferences({
                ...aiPreferences,
                suggestions: !aiPreferences.suggestions
              })} className={`w-11 h-6 rounded-full relative transition-colors flex-shrink-0 ${aiPreferences.suggestions ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-1139">
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform ${aiPreferences.suggestions ? 'left-6' : 'left-1'}`} data-id="element-1140" />
                  </button>
                </div>

                <div className="flex items-center justify-between" data-id="element-1141">
                  <div data-id="element-1142">
                    <div className="text-sm font-medium text-navy" data-id="element-1143">
                      Notifiche urgenti
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-1144">
                      Ricevi notifiche per richieste urgenti
                    </div>
                  </div>
                  <button onClick={() => setAiPreferences({
                ...aiPreferences,
                urgent: !aiPreferences.urgent
              })} className={`w-11 h-6 rounded-full relative transition-colors flex-shrink-0 ${aiPreferences.urgent ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-1145">
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform ${aiPreferences.urgent ? 'left-6' : 'left-1'}`} data-id="element-1146" />
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {/* ZONE TAB */}
        {activeTab === 'zone' && <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-1147">
            <div className="flex items-center justify-between mb-4" data-id="element-1148">
              <div className="flex items-center gap-2" data-id="element-1149">
                <MapPin size={14} className="text-gray-400" data-id="element-1150" />
                <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-1151">
                  Zone di Servizio
                </span>
              </div>
              <span className="text-xs font-medium bg-teal-50 text-teal-700 px-2 py-1 rounded-full" data-id="element-1152">
                {selectedZones.length} selezionate
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-1153">
              {allZones.map(zone => <label key={zone} className={`flex items-center p-3 rounded-lg border cursor-pointer transition-all ${selectedZones.includes(zone) ? 'border-teal-deep bg-teal-50/50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1154">
                  <div className={`w-5 h-5 rounded border flex items-center justify-center mr-3 transition-colors ${selectedZones.includes(zone) ? 'bg-teal-deep border-teal-deep' : 'border-gray-300 bg-white'}`} data-id="element-1155">
                    {selectedZones.includes(zone) && <Check size={12} className="text-white" data-id="element-1156" />}
                  </div>
                  <input type="checkbox" className="hidden" checked={selectedZones.includes(zone)} onChange={() => toggleZone(zone)} data-id="element-1157" />
                  <span className={`text-sm ${selectedZones.includes(zone) ? 'font-medium text-navy' : 'text-gray-600'}`} data-id="element-1158">
                    {zone}
                  </span>
                </label>)}
            </div>

            <button className="mt-4 flex items-center gap-2 text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors" data-id="element-1159">
              <Plus size={16} data-id="element-1160" />
              Aggiungi zona
            </button>
          </div>}

        {/* SERVIZI TAB */}
        {activeTab === 'servizi' && <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-1161">
            <div className="flex items-center justify-between mb-4" data-id="element-1162">
              <div className="flex items-center gap-2" data-id="element-1163">
                <Briefcase size={14} className="text-gray-400" data-id="element-1164" />
                <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-1165">
                  Servizi Offerti
                </span>
              </div>
              <span className="text-xs font-medium bg-teal-50 text-teal-700 px-2 py-1 rounded-full" data-id="element-1166">
                {selectedServices.length} attivi
              </span>
            </div>

            <div className="space-y-2" data-id="element-1167">
              {allServices.map(service => <label key={service} className={`flex items-center p-3 rounded-lg border cursor-pointer transition-all ${selectedServices.includes(service) ? 'border-teal-deep bg-teal-50/50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1168">
                  <div className={`w-5 h-5 rounded border flex items-center justify-center mr-3 transition-colors ${selectedServices.includes(service) ? 'bg-teal-deep border-teal-deep' : 'border-gray-300 bg-white'}`} data-id="element-1169">
                    {selectedServices.includes(service) && <Check size={12} className="text-white" data-id="element-1170" />}
                  </div>
                  <input type="checkbox" className="hidden" checked={selectedServices.includes(service)} onChange={() => toggleService(service)} data-id="element-1171" />
                  <span className={`text-sm ${selectedServices.includes(service) ? 'font-medium text-navy' : 'text-gray-600'}`} data-id="element-1172">
                    {service}
                  </span>
                </label>)}
            </div>
          </div>}

        {/* DISPONIBILITA TAB */}
        {activeTab === 'disponibilita' && <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-1173">
            <div className="flex items-center gap-2 mb-4" data-id="element-1174">
              <Clock size={14} className="text-gray-400" data-id="element-1175" />
              <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-1176">
                Disponibilità
              </span>
            </div>

            <div className="mb-6" data-id="element-1177">
              <label className="block text-sm text-gray-600 mb-3" data-id="element-1178">
                Giorni lavorativi
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-1179">
                {Object.keys(availability).map(day => <button key={day} onClick={() => toggleDay(day as keyof typeof availability)} className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all ${availability[day as keyof typeof availability] ? 'bg-teal-deep text-white' : 'bg-gray-100 text-gray-400 hover:bg-gray-200'}`} data-id="element-1180">
                    {day}
                  </button>)}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-1181">
              <div data-id="element-1182">
                <label className="block text-sm text-gray-600 mb-2" data-id="element-1183">
                  Dalle
                </label>
                <div className="relative" data-id="element-1184">
                  <select className="w-full appearance-none bg-white border border-gray-200 text-navy py-2.5 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-deep/20 text-sm" data-id="element-1185">
                    <option data-id="element-1186">08:00</option>
                    <option data-id="element-1187">09:00</option>
                    <option data-id="element-1188">10:00</option>
                  </select>
                  <ChevronDown size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-1189" />
                </div>
              </div>
              <div data-id="element-1190">
                <label className="block text-sm text-gray-600 mb-2" data-id="element-1191">Alle</label>
                <div className="relative" data-id="element-1192">
                  <select className="w-full appearance-none bg-white border border-gray-200 text-navy py-2.5 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-deep/20 text-sm" data-id="element-1193">
                    <option data-id="element-1194">17:00</option>
                    <option data-id="element-1195">18:00</option>
                    <option data-id="element-1196">19:00</option>
                  </select>
                  <ChevronDown size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-1197" />
                </div>
              </div>
            </div>
          </div>}

        {/* SAVE BUTTON */}
        <button className="w-full bg-teal-deep text-white font-medium py-3 rounded-xl hover:bg-teal-800 transition-colors flex items-center justify-center gap-2" data-id="element-1198">
          <Save size={18} data-id="element-1199" />
          Salva modifiche
        </button>
      </div>
    </MobileLayout>;
}